class Hero {
  constructor () {
    // this.moreInfo()
    this.menu()
  }

  // moreInfo () {
  //   const moreInfoButton = document.getElementById('hero-home-more-info')
  //   const section = document.querySelector('.c-flyoutForm')

  //   if (moreInfoButton !== null && section !== null) {
  //     moreInfoButton.addEventListener('click', function () {
  //       console.log(section)
  //       section.classList.toggle('isOpen')
  //     })
  //   }
  // }

  menu () {
    const menu = document.querySelector('.c-heroHome__menu')
    const open = document.querySelector('.c-heroHome__menuOpen')
    const close = document.querySelector('.c-heroHome__menuClose')

    if (menu === null) return

    const hideMenu = () => {
      menu.classList.remove('isOpen')
    }
    const handleClosure = event => {
      !menu.contains(event.target) && hideMenu()
    }

    open.addEventListener('click', function () {
      menu.classList.toggle('isOpen')
    })

    close.addEventListener('click', function () {
      menu.classList.remove('isOpen')
    })

    window.addEventListener('click', handleClosure)
    window.addEventListener('focusin', handleClosure)
  }
}

export default Hero
